import React from "react";
const WelcomeSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-orange-50 via-white to-red-50 py-16 px-4 md:px-10">
      <div className="absolute top-10 left-10 w-24 h-24 bg-orange-300 rounded-full blur-3xl opacity-25 animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-28 h-28 bg-red-300 rounded-full blur-3xl opacity-25 animate-pulse"></div>
      <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div className="order-2 lg:order-1 animate-[fadeInLeft_1s_ease-out]">
          <span className="inline-block mb-4 px-4 py-1.5 text-xs font-semibold text-red-700 bg-red-100 rounded-full">
            About Our School
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight mb-5">
            Welcome To{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Asha Modern School
            </span>
          </h2>
          <p className="text-gray-700 text-sm md:text-[15px] leading-7 text-justify mb-5">
            The school is run by the Trust{" "}
            <strong>Asharani Memorial Trust</strong> and recognised by the
            Government of Uttar Pradesh. Guided by renowned academicians, our
            school is dedicated to quality education with discipline, values and
            modern learning methods.
          </p>
          <p className="text-gray-600 text-sm md:text-[15px] leading-7 text-justify">
            We focus on academic excellence, personality development and a safe,
            inspiring environment where every child can learn, grow and shine.
          </p>
          <div className="grid grid-cols-3 gap-3 mt-6">
            <div className="bg-white rounded-2xl shadow-md p-4 text-center border border-orange-100">
              <h4 className="text-xl font-extrabold text-red-600">15+</h4>
              <p className="text-xs text-gray-600 mt-1">Years Legacy</p>
            </div>
            <div className="bg-white rounded-2xl shadow-md p-4 text-center border border-orange-100">
              <h4 className="text-xl font-extrabold text-red-600">500+</h4>
              <p className="text-xs text-gray-600 mt-1">Students</p>
            </div>
            <div className="bg-white rounded-2xl shadow-md p-4 text-center border border-orange-100">
              <h4 className="text-xl font-extrabold text-red-600">100%</h4>
              <p className="text-xs text-gray-600 mt-1">Care & Support</p>
            </div>
          </div>
          <div className="mt-7 flex flex-wrap gap-3">
            <button className="px-6 py-2.5 bg-gradient-to-r from-red-600 to-orange-500 text-white text-sm font-semibold rounded-full shadow-lg hover:-translate-y-1 transition-all duration-300">
              Read More
            </button>
            <button className="px-6 py-2.5 border border-red-500 text-red-600 text-sm font-semibold rounded-full hover:bg-red-50 transition-all duration-300">
              Contact Us
            </button>
          </div>
        </div>
        <div className="order-1 lg:order-2 flex justify-center animate-[fadeInRight_1s_ease-out]">
          <div className="relative w-full max-w-md">
            <div className="absolute -inset-3 bg-gradient-to-br from-red-500 to-orange-400 rounded-[2rem] rotate-3 opacity-20"></div>
            <div className="relative bg-white p-3 rounded-[2rem] shadow-2xl hover:scale-105 transition-transform duration-500">
              <img
                src="image1.png"
                alt="Asha Modern School"
                className="w-full h-[320px] md:h-[420px] object-cover rounded-[1.5rem]"
              />
            </div>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-40px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(40px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </section>
  );
};

export default WelcomeSection;